<template>
  <v-menu ref="menu" v-model="menuOn" lazy offset-y full-width min-width="290px">
    <v-text-field slot="activator" v-model="formattedValue" :label="label" readonly :rules="rules"></v-text-field>
    <v-date-picker :value="value" @change="updateValue" no-title scrollable :clearable="clearable"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    label: String,
    value: String,
    clearable: Boolean,
    rules: Array,
  },
  data() {
    return {
      menuOn: false,
    };
  },
  computed: {
    formattedValue() {
      return this.value || "";
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>
